import { useCallback, useRef } from 'react';
import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { PATHS } from '@/common';

interface Response {
  id?: number;
  s3_url?: string;
}

interface Payload {
  documentId: string;
  qrId?: string;
  objectKey?: string;
  employeeId?: string;
  fileName?: string;
}

const useCompleteFileUploadByQrCodeQuery = () => {
  const controllerRef = useRef(new AbortController());

  const { mutateAsync, isLoading } = useMutation(
    (payload: Payload) => {
      controllerRef.current = new AbortController();
      return api.post<Response>(PATHS.COMPLETE_FILE_UPLOAD_BY_QR_CODE(payload.documentId), {
        qr_id: payload?.qrId,
        object_key: payload?.objectKey,
        employee_id: payload?.employeeId,
        file_name: payload?.fileName,
      }, {
        signal: controllerRef.current.signal,
      });
    }
  );

  const cancelCompleteFileUpload = useCallback(() => {
    controllerRef.current.abort();
  }, []);

  return {
    completeFileUploadByQrCode: mutateAsync,
    cancelCompleteFileUpload,
    isLoading,
  };
};

export default useCompleteFileUploadByQrCodeQuery;
